<template>
  <div>
    <SimpleConfirmReset v-if="showSimpleConfirmReset" @close="$emit('close')"></SimpleConfirmReset>
    <FollowUpQuestion v-if="showFollowUpQuestion" @close="$emit('close')" enableSkip />
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import SimpleConfirmReset from './SimpleConfirmReset'
import FollowUpQuestion from './FollowUpQuestion'

export default {
  components: {
    SimpleConfirmReset,
    FollowUpQuestion
  },
  data () {
    return { }
  },
  computed: {
    ...mapGetters(['getFollowUpQuestionAsked']),
    followUpQuestionAsked () {
      return this.getFollowUpQuestionAsked
    },
    showFollowUpQuestion () {
      return !this.showSimpleConfirmReset
    },
    showSimpleConfirmReset () {
      if(this.$isUcas) {
        return true;
      }

      return this.followUpQuestionAsked
    }
  },
  methods: {
    ...mapActions(['setFollowUpQuestionAsked']),
    followUpQuestionClosed () {
      this.setFollowUpQuestionAsked()
      this.$emit('close')
    },
    triggerConfirmReset () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmReset.vue